// cookies 用户id
export const USER_ID_COOKIES_KEY = 'USER_ID'
// cookies 用户token
export const USER_TOKEN_COOKIES_KEY = 'USER_TOKEN'
export const AD_ID_COOKIES_KEY = 'AD_ID'

// localStorage 用户登录信息
export const USER_IS_LOGIN_STORE_KEY = 'USER_IS_LOGIN'
// localStoreage 用户是否购买vip
export const USER_IS_VIP_STORE_KEY = 'USER_IS_VIP'
